<template>
    <div>
      <div>
        <legend>Fichier {{type}}</legend>
        <div><i>format <span v-for="format in formats">{{ format }} </span>, sélectionner un fichier, cliquer sur 'submit', une fois l'url du fichier affichée, cliquer sur 'valider cette étape'</i></div>
      </div>
      <div>
        <label class="sr-only">Fichier {{type}}</label>
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
        <button class="btn" v-on:click="submitFile">Submit</button>
      </div>
      <div v-if="uploading"><i>chargement en cours</i></div>
      <div>Fichier actuel : <a v-bind:href="fileInfo.contentUrl" target="_blank">{{fileInfo.contentUrl}}</a></div>
    </div>
</template>

<script>

  import bdd from '../../api/bdd'

  export default {

    name: 'UploadFile',

    props: ['type', 'fileId', 'formats', 'types'],

    data() {
      return {
        uploading: false,
        file: '',
        fileInfo: {
          id: '',
          contentUrl: 'aucun fichier'
        }
      }
    },

    mounted() {
      if (this.fileId) {
        console.log('media récupéré : ' + this.fileId)
        bdd.getMedia(this.fileId)
          .then(fileInfo => {
            this.fileInfo.id = "/api/media_objects/" + fileInfo.id
            this.fileInfo.contentUrl = process.env.BASE_URL + '/media/' + fileInfo.contentUrl
          })
      }
    },

    methods: {
      /*
        Submits the file to the server
      */
      submitFile(e) {
        e.preventDefault()
        /*
                Initialize the form data
            */
        let formData = new FormData()
        /*
            Add the form data we need to submit
        */
        formData.append('file', this.file)

        this.uploading = true

        /*
          Call api to send the file
        */
        bdd.postMedia(formData)
          .then(fileInfo => {
            this.fileInfo.contentUrl = process.env.BASE_URL + '/media/' + fileInfo.contentUrl
            this.fileInfo.id = "/api/media_objects/" + fileInfo.id
            this.$emit('push-file', this.type, this.fileInfo.id, this.fileInfo.contentUrl)
            console.log('upload réussit', fileInfo)
            this.uploading = false
          })
      },

      /*
        Handles a change on the file upload
      */
      handleFileUpload() {

        console.log(this.$refs.file.files[0].type);

        // vérification que le type de fichier est accepté
        if (this.types.includes(this.$refs.file.files[0].type)) {
          // si oui on update la valeur côté vuejs
          this.file = this.$refs.file.files[0]
        } else {
          // sinon on enleve le fichier avec alerte
          this.$refs.file.value = ''
          alert('format incorect')
        }

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EditSub/UploadFile.vue